import React from 'react';
import PropTypes from 'prop-types';
import Keywords from '../common/components/keywords';
import useGetOtherKeywordsFromWiresUsingKeyword from '../../../services/keywords/other-keywords-service';

export default function TopKeywords({ keyword }) {
  const [{ data }, executeQuery] = useGetOtherKeywordsFromWiresUsingKeyword([keyword.slug], 5);

  React.useEffect(() => {
    executeQuery();
  }, [executeQuery]);

  const props = { data, relation: 'related to', query: keyword.value };
  return <Keywords {...props} />;
}

TopKeywords.propTypes = {
  keyword: PropTypes.shape({
    value: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  }).isRequired,
};
